// extracted by mini-css-extract-plugin
export default {"social":"_9ae905d5","socialButton":"_4e575103","contact":"_65b2520e","shareButton":"_7cbdb6d5","socialShareWrapper":"_85ec0e0b"};